import { render, staticRenderFns } from "./GItemSkuForm.vue?vue&type=template&id=5d428648&scoped=true&"
import script from "./GItemSkuForm.vue?vue&type=script&lang=ts&"
export * from "./GItemSkuForm.vue?vue&type=script&lang=ts&"
import style0 from "./GItemSkuForm.vue?vue&type=style&index=0&id=5d428648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d428648",
  null
  
)

export default component.exports